// The optional screen background image stays on this device, in IndexedDB.
// Nothing is uploaded: a TV wall does not roam, so per-device storage is the right fit.

const DB_NAME = "passcall";
const STORE = "settings";
const KEY = "screenBackground";
export const MAX_BACKGROUND_BYTES = 5 * 1024 * 1024;

function openDb() {
  return new Promise((resolve, reject) => {
    if (typeof indexedDB === "undefined") {
      reject(new Error("IndexedDB unavailable"));
      return;
    }
    const req = indexedDB.open(DB_NAME, 1);
    req.onupgradeneeded = () => {
      if (!req.result.objectStoreNames.contains(STORE)) req.result.createObjectStore(STORE);
    };
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}

function withStore(mode, fn) {
  return openDb().then(
    (db) =>
      new Promise((resolve, reject) => {
        const tx = db.transaction(STORE, mode);
        const req = fn(tx.objectStore(STORE));
        tx.oncomplete = () => {
          db.close();
          resolve(req && req.result);
        };
        tx.onerror = () => {
          db.close();
          reject(tx.error);
        };
      })
  );
}

export function saveBackground(blob) {
  if (!(blob instanceof Blob)) return Promise.reject(new Error("not a file"));
  if (!/^image\//.test(blob.type)) return Promise.reject(new Error("not an image"));
  if (blob.size > MAX_BACKGROUND_BYTES) return Promise.reject(new Error("image larger than 5 MB"));
  return withStore("readwrite", (store) => store.put(blob, KEY));
}

/** The stored image as a Blob, or null. */
export function loadBackground() {
  return withStore("readonly", (store) => store.get(KEY)).then((v) => (v instanceof Blob ? v : null)).catch(() => null);
}

export function clearBackground() {
  return withStore("readwrite", (store) => store.delete(KEY)).catch(() => null);
}
